<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import ReportMetricCard from './ReportMetricCard.vue';
import { AI_AGENT_METRICS } from 'dashboard/store/modules/reports';

const { t } = useI18n();
const summary = useMapGetter('getAiAgentsSummary');

const cards = computed(() =>
  AI_AGENT_METRICS.map(key => ({
    key,
    label: t(`REPORT.METRICS.${key.toUpperCase()}.NAME`),
    infoText: t(`REPORT.METRICS.${key.toUpperCase()}.DESC`),
    value: Number(summary.value?.[key] || 0).toLocaleString(),
  }))
);
</script>

<template>
  <div
    class="grid grid-cols-2 gap-x-6 gap-y-5 mx-0 shadow outline-1 outline outline-n-container rounded-xl bg-n-solid-2 px-6 py-5 md:grid-cols-4"
  >
    <ReportMetricCard
      v-for="card in cards"
      :key="card.key"
      :label="card.label"
      :info-text="card.infoText"
      :value="card.value"
    />
  </div>
</template>
